import { useContext } from 'react';
import { useGameResources } from '@disco/hooks';
import { UserDiscoData, UserDiscoContext } from '@disco/ui';

export const useResources = (id) => {
  const { token } = useContext<UserDiscoData>(UserDiscoContext);
  const resources = useGameResources(id, token);
  return resources;
};
